import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	documentTitle: {
		id: 'spa-apps.project-settings.service-desk-automation.document-title',
		defaultMessage: 'Legacy Automation',
		description: 'This text is displayed as a document title',
	},
});
